import { ChannelSchema } from "@redotech/redo-marketplace-common/channels";
import * as z from "zod";
import { ProductCatalogItemSchema_ } from "./get-product-catalog";

const ConsignmentCatalogItemSchema = ProductCatalogItemSchema_.extend({
  channels: z.array(ChannelSchema),
});
export type ConsignmentCatalogItem = z.infer<
  typeof ConsignmentCatalogItemSchema
>;

export const getConsignmentCatalog = {
  name: "getConsignmentCatalog" as const,
  input: z.object({
    pageSize: z.number().min(1).max(100).optional().default(20),
    page: z.number().min(0).optional().default(0),
    search: z.string().optional(),
  }),
  output: z.object({
    catalogItems: z.array(ConsignmentCatalogItemSchema),
    totalCount: z.number(),
    page: z.number(),
    pageSize: z.number(),
  }),
};
